export const palette = {
  blue: {
    light: '#415c8d',
    main: '#2a477f',
    dark: '#123371',
  },
}
